"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPackageTheme = exports.getFiltrationPipe = exports.getFiltrationByKey = exports.getFiltration = exports.getDebugModeStatus = exports.getActiveCameraPerspective = void 0;
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../utils/constants");
const getPackageTheme = _ref => {
  let {
    [_constants.packageKey]: {
      viewer
    } = {}
  } = _ref;
  return (viewer === null || viewer === void 0 ? void 0 : viewer.theme) || _paulCorePackage.constants.themeKey.light;
};
exports.getPackageTheme = getPackageTheme;
const getDebugModeStatus = _ref2 => {
  let {
    [_constants.packageKey]: {
      viewer
    } = {}
  } = _ref2;
  return (viewer === null || viewer === void 0 ? void 0 : viewer.debugModeStatus) || false;
};
exports.getDebugModeStatus = getDebugModeStatus;
const getFiltration = _ref3 => {
  let {
    [_constants.packageKey]: {
      viewer
    } = {}
  } = _ref3;
  return (viewer === null || viewer === void 0 ? void 0 : viewer.filtration) || {};
};
exports.getFiltration = getFiltration;
const getFiltrationByKey = key => _ref4 => {
  let {
    [_constants.packageKey]: {
      viewer
    } = {}
  } = _ref4;
  return ((viewer === null || viewer === void 0 ? void 0 : viewer.filtration) || {})[key];
};
exports.getFiltrationByKey = getFiltrationByKey;
const getFiltrationPipe = pipe => _ref5 => {
  let {
    [_constants.packageKey]: {
      viewer
    } = {}
  } = _ref5;
  return ((viewer === null || viewer === void 0 ? void 0 : viewer.filtration) || {})[pipe];
};
exports.getFiltrationPipe = getFiltrationPipe;
const getActiveCameraPerspective = _ref6 => {
  let {
    [_constants.packageKey]: {
      viewer
    } = {}
  } = _ref6;
  return (viewer === null || viewer === void 0 ? void 0 : viewer.activeCameraPerspective) || _constants.CameraPerspective.ThreeD;
};
exports.getActiveCameraPerspective = getActiveCameraPerspective;